export default __webpack_public_path__ + "static/media/view.1527e8f0.svg";